import React from 'react';
import { Card } from 'react-bootstrap';


const KindergartenInfo = ({kindergartenData}) => {

    return (
            <Card className="contact-card">
              <Card.Body>
                <h3 className="contact-title">Контакти</h3>
                
                <div className="contact-item">
                  <div className="contact-label">Адреса</div>
                  <div className="contact-value">{kindergartenData.contacts.address.string}</div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">Директор</div>
                  <div className="contact-value">{kindergartenData.head.firstName}</div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">Телефон</div>
                  <div className="contact-value">
                    {kindergartenData.contacts.phones.map((phone, index) => (
                      <span key={index}>
                        <a href={`tel:${phone}`}>{phone}</a>
                        {index < kindergartenData.contacts.phones.length - 1 && ', '}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">E-mail</div>
                  <div className="contact-value">
                    <a href={`mailto:${kindergartenData.contacts.email}`}>
                      {kindergartenData.contacts.email}
                    </a>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">Сайт</div>
                  <div className="contact-value">
                    <a href={kindergartenData.contacts.site} target="_blank" rel="noopener noreferrer">
                      {kindergartenData.website}
                    </a>
                  </div>
                </div>

                {/* Schedule Section */}
                <div className="schedule-section">
                  <h4 className="schedule-title">Режим роботи</h4>
                  
                  
                    <div key="schedule-item" className="schedule-item">
                      <div className="schedule-day">{kindergartenData.workingHours.daysOfWeek.join(",") || "Пн-Пт"}</div>
                      <div className="schedule-time">{kindergartenData.workingHours.timeFrom}-{kindergartenData.workingHours.timeTo}</div>
                    </div>
                  
                </div>

                {/* Additional Info */}
                <div className="additional-info">
                  <h4 className="additional-title">Спеціалізація</h4>
                  <p className="additional-text">{kindergartenData.specialization}</p>

                  <h4 className="additional-title">Додаткові сервіси</h4>
                  <p className="additional-text">{kindergartenData.additionalServices && kindergartenData.additionalServices.entity || "Не має"}</p>

                  <h4 className="additional-title">Медичне сплудження</h4>
                  <p className="additional-text">{kindergartenData.specifics}</p>

                  <h4 className="additional-title">Часи та особливості</h4>
                  <p className="additional-text">{kindergartenData.existence && [kindergartenData.existence].join(", ") || ''}</p>
                </div>
              </Card.Body>
            </Card>
    )

}

export default KindergartenInfo;